import React from 'react';

const IconCloseHQ = () => (
  <svg width="14" height="14" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.293 1.293a1 1 0 0 1 1.32-.083l.094.083 24 24a1 1 0 0 1-1.32 1.497l-.094-.083-24-24a1 1 0 0 1 0-1.414" />
    <path d="M26.707 1.293a1 1 0 0 0-1.32-.083l-.094.083-24 24a1 1 0 0 0 1.32 1.497l.094-.083 24-24a1 1 0 0 0 0-1.414" />
  </svg>
);

export default IconCloseHQ;
